import React from "react";
import { Button, Modal } from "../../../../../components";

const ApplicantRejectModal = ({
  rejectApplicantModalOpen,
  setRejectApplicantModalOpen,
  setViewModalOpen,
  actionsHandler,
}) => {
  return (
    <Modal
      isOpen={rejectApplicantModalOpen}
      title={"Applicant Reject"}
      titleColor={"black"}
      showCloseButton={false}
      width="max-w-2xl"
    >
      <div className="flex flex-col gap-2">
        <div>Are you sure you want to reject this applicant ?</div>
        <div>
          If Yes, Applicant will be removed permanently from onboarding list.
        </div>
        <div className="flex items-center justify-center gap-4 mt-15">
          <Button
            title={"Cancel"}
            variant="outlined"
            className="!py-1"
            onClick={() => {
              setRejectApplicantModalOpen(false);
              // setViewModalOpen(false);
            }}
          />
          <Button title={"Yes"} className="!py-1" onClick={()=>actionsHandler("reject")}/>
        </div>
      </div>
    </Modal>
  );
};

export default ApplicantRejectModal;
